<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h4 class="mb-0">
        <a-icon type="history" class="mr-2" />
        {{ $t("paiementHistory.title") }}
      </h4>
    </div>
    <div class="card-body">
      <!-- Filters -->
      <div class="filters-section decaissement-filters-stacked">
        <div class="filters-header decaissement-filters-header">
          <h4>
            <a-icon type="filter" class="filter-icon" />
            {{ $t("all.filtresEtRecherche") }}
          </h4>
          <div class="action-button-group">
            <a-button class="action-button" @click="resetFilters">
              {{ $t("factures.resetFilters") }}
            </a-button>
            <a-button
              type="primary"
              class="action-button"
              @click="applyFilters"
            >
              {{ $t("action.search") }}
            </a-button>
          </div>
        </div>
        <a-row :gutter="[16, 16]" type="flex" class="decaissement-filters-row">
          <a-col :xs="24" :sm="12" :md="12" :lg="8" class="filter-col">
            <div class="filter-item filter-item-stack">
              <label class="filter-label">
                <a-icon type="search" class="action-icon" />
                {{ $t("paiementHistory.searchReceipt") }}
              </label>
              <a-input
                v-model="filters.search"
                allow-clear
                class="filter-control"
                :placeholder="$t('paiementHistory.searchReceipt')"
                @pressEnter="applyFilters"
              >
                <a-icon slot="prefix" type="search" />
              </a-input>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" class="filter-col">
            <div class="filter-item filter-item-stack">
              <label class="filter-label">
                <a-icon type="swap" class="action-icon" />
                {{ $t("paiementHistory.paymentMode") }}
              </label>
              <a-select
                v-model="filters.paymentMode"
                allow-clear
                class="filter-control"
                :placeholder="$t('all.tpiAll')"
                @change="applyFilters"
              >
                <a-select-option value="immediate">{{
                  $t("paiementHistory.immediate")
                }}</a-select-option>
                <a-select-option value="scheduled">{{
                  $t("paiementHistory.scheduled")
                }}</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" class="filter-col">
            <div class="filter-item filter-item-stack">
              <label class="filter-label">
                <a-icon type="check-circle" class="action-icon" />
                {{ $t("paiementHistory.status") }}
              </label>
              <a-select
                v-model="filters.status"
                allow-clear
                class="filter-control"
                :placeholder="$t('all.tpiAll')"
                @change="applyFilters"
              >
                <a-select-option value="completed">{{
                  $t("paiementHistory.statuses.completed")
                }}</a-select-option>
                <a-select-option value="pending">{{
                  $t("paiementHistory.statuses.pending")
                }}</a-select-option>
                <a-select-option value="cancelled">{{
                  $t("paiementHistory.statuses.cancelled")
                }}</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" class="filter-col">
            <div class="filter-item filter-item-stack">
              <label class="filter-label">
                <a-icon type="safety-certificate" class="action-icon" />
                {{ $t("paiementHistory.validationStatus") }}
              </label>
              <a-select
                v-model="filters.validationStatus"
                allow-clear
                class="filter-control"
                :placeholder="$t('all.tpiAll')"
                @change="applyFilters"
              >
                <a-select-option value="pending_validation">{{
                  $t("paiementHistory.validationStatuses.pending_validation")
                }}</a-select-option>
                <a-select-option value="validated">{{
                  $t("paiementHistory.validationStatuses.validated")
                }}</a-select-option>
                <a-select-option value="rejected">{{
                  $t("paiementHistory.validationStatuses.rejected")
                }}</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" class="filter-col">
            <div class="filter-item filter-item-stack">
              <label class="filter-label">
                <a-icon type="credit-card" class="action-icon" />
                {{ $t("paiementHistory.method") }}
              </label>
              <a-select
                v-model="filters.method"
                allow-clear
                class="filter-control"
                :placeholder="$t('all.tpiAll')"
                @change="applyFilters"
              >
                <a-select-option value="cash">{{
                  $t("decaissement.paymentMethod.cash")
                }}</a-select-option>
                <a-select-option value="cheque">{{
                  $t("decaissement.paymentMethod.cheque")
                }}</a-select-option>
                <a-select-option value="virement">{{
                  $t("decaissement.paymentMethod.virement")
                }}</a-select-option>
                <a-select-option value="traite">{{
                  $t("decaissement.paymentMethod.traite")
                }}</a-select-option>
                <a-select-option value="tpe">{{
                  $t("decaissement.paymentMethod.tpe")
                }}</a-select-option>
                <a-select-option value="prelevement">{{
                  $t("decaissement.paymentMethod.prelevement")
                }}</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" class="filter-col">
            <div class="filter-item filter-item-stack">
              <label class="filter-label">
                <a-icon type="calendar" class="action-icon" />
                {{ $t("paiementHistory.dateRange") }}
              </label>
              <a-range-picker
                v-model="filters.dateRange"
                class="filter-control date-range-filter"
                format="DD/MM/YYYY"
                style="width: 100%"
                @change="applyFilters"
              />
            </div>
          </a-col>
        </a-row>
      </div>

      <!-- Legend -->
      <div class="legend-bar mb-3">
        <div class="legend-bar-inner">
          <div class="legend-bar-methods">
            <span class="legend-item"
              ><a-icon type="wallet" class="legend-cash" />
              {{ $t("decaissement.paymentMethod.cash") }}</span
            >
            <span class="legend-item"
              ><a-icon type="credit-card" class="legend-cheque" />
              {{ $t("decaissement.paymentMethod.cheque") }}</span
            >
            <span class="legend-item"
              ><a-icon type="bank" class="legend-virement" />
              {{ $t("decaissement.paymentMethod.virement") }}</span
            >
            <span class="legend-item"
              ><a-icon type="file-protect" class="legend-traite" />
              {{ $t("decaissement.paymentMethod.traite") }}</span
            >
            <span class="legend-item"
              ><a-icon type="tablet" class="legend-tpe" />
              {{ $t("decaissement.paymentMethod.tpe") }}</span
            >
            <span class="legend-item"
              ><a-icon type="sync" class="legend-prelevement" />
              {{ $t("decaissement.paymentMethod.prelevement") }}</span
            >
          </div>
          <div
            class="legend-debt-row"
            :title="$t('decaissement.legendDebtRowHint')"
          >
            <span class="legend-debt-swatch" aria-hidden="true" />
            <span>{{ $t("decaissement.legendDebtRow") }}</span>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="table-container">
        <a-table
          row-key="_id"
          :loading="loading"
          :columns="columns"
          :data-source="rows"
          :pagination="tablePagination"
          :scroll="{ x: 'max-content' }"
          :custom-row="rowClickHandler"
          :row-class-name="rowClassName"
          @change="onTableChange"
        >
          <template slot="date" slot-scope="text">
            <span class="date-cell">{{ formatDate(text) }}</span>
          </template>
          <template slot="beneficiary" slot-scope="text">
            <span class="client-name">{{ text || "—" }}</span>
          </template>
          <template slot="benType" slot-scope="text">
            <span v-if="text === 'provider'" class="ben-type"
              ><a-icon type="shop" class="legend-provider" />
              {{ $t("factures.beneficiaryProvider") }}</span
            >
            <span v-else-if="text === 'associate'" class="ben-type"
              ><a-icon type="team" class="legend-associate" />
              {{ $t("factures.beneficiaryAssociate") }}</span
            >
            <span v-else-if="text === 'employee'" class="ben-type"
              ><a-icon type="user" class="legend-employee" />
              {{ $t("factures.beneficiaryEmployee") }}</span
            >
            <span v-else-if="text === 'company'" class="ben-type"
              ><a-icon type="apartment" class="legend-company" />
              {{ $t("factures.beneficiaryCompany") }}</span
            >
            <span v-else-if="text === 'debiteur'" class="ben-type"
              ><a-icon type="bank" class="legend-debiteur" />
              {{ $t("factures.beneficiaryDebiteur") }}</span
            >
            <span v-else>—</span>
          </template>
          <template slot="amount" slot-scope="text">
            <span class="amount-cell">{{
              text != null ? text.toFixed(3) : "—"
            }}</span>
          </template>
          <template slot="method" slot-scope="text, record">
            <span
              v-if="!record.methods || !record.methods.length"
              class="text-muted"
              >—</span
            >
            <span
              v-else-if="record.methods.length > 1"
              class="payment-method-cell payment-method-multi"
            >
              <a-icon
                v-for="m in record.methods"
                :key="m"
                :type="paymentMethodIcon(m)"
                :class="paymentMethodLegendClass(m)"
                class="mixed-icon mr-1"
              />
            </span>
            <span v-else class="payment-method-cell payment-method-single">
              <a-icon
                :type="paymentMethodIcon(record.methods[0])"
                :class="paymentMethodLegendClass(record.methods[0])"
                class="mr-1"
              />
              {{ $t("decaissement.paymentMethod." + record.methods[0]) }}
            </span>
          </template>
          <template slot="status" slot-scope="text, record">
            <a-tag :color="statusColor(displayStatusKey(record))">{{
              $t("paiementHistory.statuses." + displayStatusKey(record))
            }}</a-tag>
          </template>
          <template slot="valStatus" slot-scope="text">
            <a-tag :color="valStatusColor(text)">{{
              $t("paiementHistory.validationStatuses." + text)
            }}</a-tag>
          </template>
          <template slot="payMode" slot-scope="text">
            <a-tag :color="text === 'immediate' ? 'blue' : 'purple'">
              {{
                text === "immediate"
                  ? $t("paiementHistory.immediate")
                  : $t("paiementHistory.scheduled")
              }}
            </a-tag>
          </template>
          <template slot="action" slot-scope="text, record">
            <a-button
              type="link"
              size="small"
              @click.stop="openDrawer(record._id)"
            >
              <a-icon type="eye" />
            </a-button>
          </template>
        </a-table>
      </div>
      <div
        v-if="!loading && rows.length === 0"
        class="text-center text-muted py-4 empty-state"
      >
        {{ $t("paiementHistory.noPayments") }}
      </div>
    </div>

    <payment-detail-drawer
      :visible="drawerVisible"
      :payment-id="drawerPaymentId"
      @close="drawerVisible = false"
    />
  </div>
</template>

<script>
import moment from "moment";
import { fetchPaymentHistory } from "@/services/api/compV3/paymentEntry";
import PaymentDetailDrawer from "./PaymentDetailDrawer.vue";

export default {
  name: "PaymentHistoryPage",
  components: { PaymentDetailDrawer },
  data() {
    return {
      rows: [],
      loading: false,
      pagination: { current: 1, pageSize: 20, total: 0 },
      filters: {
        search: "",
        paymentMode: undefined,
        status: undefined,
        validationStatus: undefined,
        method: undefined,
        dateRange: [],
      },
      drawerVisible: false,
      drawerPaymentId: null,
    };
  },
  computed: {
    tablePagination() {
      return {
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
        total: this.pagination.total,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
        showTotal: (t) => `${t}`,
      };
    },
    columns() {
      return [
        {
          title: this.$t("paiementHistory.date"),
          dataIndex: "paidAt",
          key: "date",
          width: 120,
          scopedSlots: { customRender: "date" },
        },
        {
          title: this.$t("paiementHistory.paymentMode"),
          dataIndex: "paymentMode",
          key: "payMode",
          width: 120,
          scopedSlots: { customRender: "payMode" },
        },
        {
          title: this.$t("saisiePaiement.filterBeneficiaryType"),
          dataIndex: "_beneficiaryType",
          key: "benType",
          width: 140,
          scopedSlots: { customRender: "benType" },
        },
        {
          title: this.$t("saisiePaiement.beneficiary"),
          dataIndex: "_beneficiaryNames",
          key: "ben",
          ellipsis: true,
          scopedSlots: { customRender: "beneficiary" },
        },
        {
          title: this.$t("saisiePaiement.invoiceRef"),
          dataIndex: "_invoiceRefs",
          key: "refs",
          ellipsis: true,
        },
        {
          title: this.$t("recette.montant"),
          dataIndex: "totalToPay",
          key: "amt",
          width: 120,
          scopedSlots: { customRender: "amount" },
        },
        {
          title: this.$t("paiementHistory.method"),
          dataIndex: "methods",
          key: "method",
          width: 220,
          scopedSlots: { customRender: "method" },
        },
        {
          title: this.$t("paiementHistory.status"),
          dataIndex: "status",
          key: "status",
          width: 120,
          scopedSlots: { customRender: "status" },
        },
        {
          title: this.$t("paiementHistory.validationStatus"),
          dataIndex: "validationStatus",
          key: "valSt",
          width: 140,
          scopedSlots: { customRender: "valStatus" },
        },
        {
          title: "",
          key: "action",
          width: 50,
          scopedSlots: { customRender: "action" },
        },
      ];
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    formatDate(d) {
      return d ? moment(d).format("DD/MM/YYYY") : "—";
    },
    statusColor(s) {
      if (s === "awaiting_validation") return "orange";
      return s === "completed" ? "green" : s === "pending" ? "orange" : "red";
    },
    displayStatusKey(record) {
      if (
        record &&
        record.validationStatus === "pending_validation" &&
        record.caisseDebitApplied === false
      ) {
        return "awaiting_validation";
      }
      return record && record.status ? record.status : "pending";
    },
    valStatusColor(s) {
      return s === "validated" ? "green" : s === "rejected" ? "red" : "orange";
    },
    paymentMethodIcon(m) {
      const map = {
        cash: "wallet",
        cheque: "credit-card",
        virement: "bank",
        traite: "file-protect",
        prelevement: "sync",
        tpe: "tablet",
      };
      return map[m] || "dollar";
    },
    paymentMethodLegendClass(m) {
      const map = {
        cash: "legend-cash",
        cheque: "legend-cheque",
        virement: "legend-virement",
        traite: "legend-traite",
        tpe: "legend-tpe",
        prelevement: "legend-prelevement",
      };
      return map[m] || "";
    },
    buildQueryParams() {
      const p = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
      };
      if (this.filters.search) p.search = this.filters.search;
      if (this.filters.paymentMode) p.paymentMode = this.filters.paymentMode;
      if (this.filters.status) p.status = this.filters.status;
      if (this.filters.validationStatus)
        p.validationStatus = this.filters.validationStatus;
      if (this.filters.method) p.method = this.filters.method;
      if (this.filters.dateRange && this.filters.dateRange.length === 2) {
        p.dateFrom = this.filters.dateRange[0].format("YYYY-MM-DD");
        p.dateTo = this.filters.dateRange[1].format("YYYY-MM-DD");
      }
      return p;
    },
    async fetchData() {
      this.loading = true;
      try {
        const res = await fetchPaymentHistory(this.buildQueryParams());
        const body = res.data || {};
        this.rows = body.data || [];
        this.pagination.total = body.total || 0;
        this.pagination.current = body.page || 1;
      } catch {
        this.$message.error(this.$t("warning.connectionProblem"));
      } finally {
        this.loading = false;
      }
    },
    applyFilters() {
      this.pagination.current = 1;
      this.fetchData();
    },
    resetFilters() {
      this.filters = {
        search: "",
        paymentMode: undefined,
        status: undefined,
        validationStatus: undefined,
        method: undefined,
        dateRange: [],
      };
      this.applyFilters();
    },
    onTableChange(pag) {
      this.pagination.current = pag.current;
      this.pagination.pageSize = pag.pageSize;
      this.fetchData();
    },
    rowClickHandler(record) {
      return { on: { click: () => this.openDrawer(record._id) } };
    },
    rowClassName(record, index) {
      const stripe = index % 2 === 0 ? "table-row-even" : "table-row-odd";
      const debt = record._debt ? "row-debt-payment" : "";
      return `${stripe} ${debt}`.trim();
    },
    openDrawer(id) {
      this.drawerPaymentId = id;
      this.drawerVisible = true;
    },
  },
};
</script>

<style scoped>
.legend-bar-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 20px;
}
.legend-bar-methods {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px 28px;
}
.legend-bar {
  padding: 10px 14px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
}
.legend-item {
  font-size: 12px;
  color: #595959;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.legend-cash {
  color: #52c41a;
}
.legend-cheque {
  color: #1890ff;
}
.legend-virement {
  color: #722ed1;
}
.legend-traite {
  color: #fa8c16;
}
.legend-tpe {
  color: #eb2f96;
}
.legend-prelevement {
  color: #13c2c2;
}
.legend-mixed {
  color: #8c8c8c;
}

.payment-method-cell {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 8px;
  font-size: 13px;
}
.payment-method-mixed .mixed-label {
  font-weight: 500;
  color: #595959;
}
.payment-method-mixed .mixed-icons {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.payment-method-mixed .mixed-icon {
  font-size: 16px;
}
.payment-method-single {
  color: #262626;
}
</style>

<style>
@import "~@/views/compV3/common.css";
.row-debt-payment td {
  background: #f9f0ff !important;
}
</style>
